import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 48BA3B7B-1EF7-4160-A0BB-54EBCF999A13
 * name check-all
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check-all.svg
 * tags
 */
export const CheckAllIcon = createSvgIcon(<><path d="M0.41,13.41L6,19L7.41,17.58L1.83,12M22.24,5.58L11.66,16.17L7.5,12L6.07,13.41L11.66,19L23.66,7M18,7L16.59,5.58L10.24,11.93L11.66,13.34L18,7Z" /></>, 'CheckAllIcon');
export default CheckAllIcon